export default (theme) => ({
  container: {
    marginLeft: 220,
    paddingTop: 70
  },
  root: {
    padding: 0
  },
  tabStyle: {
    borderBottom: "1px solid rgba(0,0,0,.1)"
  }
})